import React from "react";
import CaroselloHome from "../components/home/CaroselloHome";
import "../styles/Home.css"
import {useNavigate} from "react-router-dom";
import GroupCard from "../components/home/GroupCard";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import CardNews from "../components/CardNews";
import pmarzo from "../images/News/Promo_marzo_2.png";
import fitness from "../images/News/EventoFitness.jpeg";
import carnevale from "../images/News/Carnevale/IMG_9635-2.jpg";
import CardInEvidenza from "../components/spa/CardInEvidenza";
import barista from "../images/News/Barista.png";
import promo from "../images/News/Promo_fine_stagione.png";
import CardNewsEvidenza from "../components/CardNewsEvidenza";

interface HomeProps {

}


function Home(_:HomeProps) {
    const navigate = useNavigate()
    return(
        <div>
            <ScrollToTopOnMount />
            <CaroselloHome />
            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>



            <div className="d-flex flex-column align-items-center">


                <TitoloSezioni title="Attività" />
            <GroupCard />
                <Space />
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <button
                            style={{maxWidth: "40em", minWidth: "20em", height: "4em", borderRadius: "1em", borderColor: "#2F719DFF"}}
                            type="button" className="btn custom-btn"
                            onClick={()=> navigate("/chisiamo")}
                        >
                            <h4>Scopri il centro</h4>
                        </button>
                    </blockquote>
                </figure>
            </div>
            <SpaceL />
            <div className="m-auto" style={{maxWidth: "90%"}}>
                <p style={{fontSize: "32px", fontFamily: "Hammersmith One"}}>In evidenza</p>
                <hr/>
                   <div className="d-none d-sm-block" >
                       <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>

                            <CardInEvidenza foto={promo} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"./news/promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
                           <CardInEvidenza foto={barista} titolo={"Il Cigno Café"} descrizione={""} data={"11.04.2024"} indirizzo={"./news/barista"} settore1={"ilcignocafé"} posizioneFoto={"top"}/>
                       </div>
                    </div>
                    <div className="d-sm-none  " >
                        <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>

                            <CardNewsEvidenza foto={promo} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"./news/promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
                            <CardNewsEvidenza foto={barista} titolo={"Il Cigno Café"} descrizione={""} data={"11.04.2024"} indirizzo={"./news/barista"} settore1={"ilcignocafé"} posizioneFoto={"top"}/>
                        </div>
                    </div>

            </div>
            <Space />
        </div>
    )
}

export default Home